<template>
  <el-form-item :label="item.title" :required="item.required&&item.required[operatorType]">
    <el-input :type="item.type" v-model="insideValue" :disabled="disabled"
              :οnkeyup="insideValue=insideValue.replace(/[^\w]/g,'')"
              :placeholder="disabled?'':`请输入${item.title}`"
              v-if="type==='english-input'"/>
    <el-input :type="item.type" v-model="insideValue" :disabled="disabled"
              :class="item.param==='remark'||item.param==='yarnType'?'lang-input':'normal'"
              :placeholder="disabled?'':`请输入${item.title}`"
              v-if="type==='input'"
              :maxlength="item.param==='remark'?item.maxlength:null"/>
    <el-input-number v-model="insideValue" :disabled="disabled" v-if="type==='input-number'"
                     :step="item.style.step" :step-strictly="Boolean(item.style.step)"
                     :precision="item.style.precision"
                     :placeholder="`请输入${item.title}`"
                     :controls="false"
                     :min="0"/>
    <el-select v-model="insideValue" :placeholder="disabled?'':`请选择${item.title}`"
               :disabled="disabled" @change="change"
               v-if="type==='select'">
      <el-option v-for="i in item.selectList"
                 :key="i.value" :label="i.label" :value="i.value">
      </el-option>
    </el-select>
    <el-switch v-if="type==='switch'"
               v-model="insideValue" :disabled="disabled"
               :class="[item.style&&item.style.inactive?'':'el-switch-font']"
               :active-text="item.style&&item.style.active?item.style.active:'是'"
               :inactive-text="item.style&&item.style.inactive?item.style.inactive:'否'"
               active-color="#5faee3" inactive-color="#d2d2d2"/>
    <slot :data="item" v-if="type==='slot'"/>
  </el-form-item>
</template>

<script>
  /**
   * @Description: 新版封装el-form-item组件
   * @Author: 菩萨蛮
   * @Date: 2020/9/27 11:03 上午
   * @Version v1.0.0
   *
   * 公司的业务千篇一律，复杂的代码好几百行。
   */

  export default {
    name: 'QxNewFormItem',
    props: {
      item: { type: Object },
      value: { type: null },
      disabled: { type: Boolean },
      defaultValue: { type: String },
      operatorType: { type: String, default: 'new' }
    },
    data() {
      return {
        type: 'input',
        insideValue: null
      };
    },
    watch: {
      value() {
        this.insideValue = this.value;
      },
      insideValue() {
        this.$emit('update:value', this.insideValue);
      }
    },
    created() {
      this.insideValue = this.value;
      if (this.item.type === 'input' || this.item.type === 'textarea') {
        this.type = 'input';
      } else if (this.item.type === 'select') {
        this.type = 'select';
      } else if (this.item.type === 'number') {
        this.type = 'input-number';
      } else if (this.item.type === 'english-input') {
        this.type = 'english-input';
      } else if (this.item.type === 'boolean') {
        this.type = 'switch';
      } else {
        this.type = 'slot';
      }
    },
    methods: {
      change(data) {
        this.$emit('change', data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-input-group {
    vertical-align: middle;

    .el-button {
      margin: -1px -20px;
      font-size: 25px;
      line-height: 25px;
    }
  }
</style>
